@if ((reportsLoading$ | async) === false) {
  <div>
    @if (reportData$ | async; as reportData) {
      <p-card class="w-full">
        <div class="flex w-full justify-between pb-2">
          <button
            pButton
            pRipple
            type="button"
            label="{{ 'menu.back' | translate }}"
            class="p-button-secondary"
            [routerLink]="['../1']"
          ></button>
          <partikelart-export-split-button
            (exportTriggered)="downloadReports($event)"
            (defaultExport)="downloadReports()"
            [disabled]="currentSelectedReportsForExport.length === 0"
            >
          </partikelart-export-split-button>
        </div>
        <partikelart-export-report-table
          class="w-full"
          [reports]="reportData"
          (selectedReportsEvent)="selectedReportsChange($event)"
        ></partikelart-export-report-table>
      </p-card>
    }
  </div>
} @else {
  <div class="d-flex justify-content-center">
    <div class="loader">{{ "loading" | translate }}...</div>
  </div>
}
